import { SellForm } from '@hypercharge/bbs-website-commons/lib/types/bbs';
import { hyperfetch, json, save } from '../utils/httpClient';

export async function sendSellForm(form: SellForm, recaptchaResponse: string) {
  const fetchResponse = hyperfetch<boolean>('/api/send-sell-form', {
    body: json({
      form,
      recaptchaResponse
    }),
    method: 'POST'
  });

  const requestState = await save(fetchResponse);

  return requestState;
}
